// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// Official AirWorks brand palette for every Khora chart surface (see the brand guide):
//   Bright Blue #01A1DD · Bright Orange #FF9424 · Mid Sky Blue #408BBB · Midnight Blue #153B5A
//   Light Blue #B9E2F1 · Light Gray #D9D9D9.
// Two lists because the surfaces have different grounds:
//   LIGHT — chat bubble charts, map-popup charts, widget previews (light background); uses the full set.
//   DARK  — the dashboard panel (translucent midnight); DROPS Midnight Blue (invisible on the dark
//           ground) and leads with the lighter brand colors.
// The last one or two entries are brand-DERIVED tints (a deeper Bright Blue, a lighter Bright Orange,
// a Bright/Light-Blue mid-tone) so charts with more categories than the base palette still read — they
// stay in the brand's blue/orange family rather than introducing an off-brand hue.
export const CHART_COLORS_LIGHT = [
  '#01A1DD', '#FF9424', '#153B5A', '#408BBB', '#B9E2F1', '#D9D9D9', '#0179A8', '#FFC061',
];

export const CHART_COLORS_DARK = [
  '#01A1DD', '#FF9424', '#B9E2F1', '#408BBB', '#7FC3E4', '#FFC061', '#D9D9D9',
];
